
import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Page } from '../App';
import Logo from './Logo';

interface NavbarProps {
  currentPage: Page;
  onNavigate: (page: Page) => void;
}

const Navbar: React.FC<NavbarProps> = ({ currentPage, onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems: { label: string; value: Page }[] = [
    { label: 'Home', value: 'home' },
    { label: 'Products', value: 'products' },
    { label: 'Pricing', value: 'pricing' },
    { label: 'About', value: 'about' },
    { label: 'Contact', value: 'contact' },
  ];

  const handleNav = (page: Page) => {
    onNavigate(page);
    setIsOpen(false);
  };

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-100">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-28">
          <div 
            className="flex items-center cursor-pointer h-20" 
            onClick={() => onNavigate('home')}
          >
            <Logo className="h-full" />
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-10">
            <div className="flex items-center gap-8">
              {navItems.map((item) => (
                <button 
                  key={item.value} 
                  onClick={() => handleNav(item.value)}
                  className={`text-sm font-bold uppercase tracking-widest transition-colors ${
                    currentPage === item.value ? 'text-green-700 border-b-2 border-green-700 pb-1' : 'text-slate-500 hover:text-green-600'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
            <div className="flex items-center gap-6 pl-8 border-l border-slate-100">
              <div className="flex items-center gap-2 text-slate-600">
                <Phone size={16} className="text-green-600" />
                <span className="text-sm font-bold tracking-tight">98869 78555</span>
              </div>
              <button 
                onClick={() => handleNav('contact')}
                className="bg-green-700 hover:bg-green-800 text-white px-6 py-3 rounded-xl font-bold transition-all shadow-lg shadow-green-100 text-xs uppercase tracking-widest"
              >
                Free Site Audit
              </button>
            </div>
          </div>

          {/* Mobile Toggle */}
          <button className="lg:hidden p-2 text-slate-600" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="lg:hidden absolute top-28 left-0 w-full bg-white border-b border-slate-200 shadow-2xl animate-in slide-in-from-top-2">
          <div className="flex flex-col p-6 gap-2">
            {navItems.map((item) => (
              <button 
                key={item.value} 
                onClick={() => handleNav(item.value)}
                className={`text-left p-4 rounded-xl font-bold uppercase tracking-widest text-sm ${
                  currentPage === item.value ? 'bg-green-50 text-green-700' : 'text-slate-600 hover:bg-slate-50'
                }`}
              >
                {item.label}
              </button>
            ))}
            <button 
              onClick={() => handleNav('contact')}
              className="mt-4 bg-green-700 text-white text-center p-4 rounded-xl font-bold uppercase tracking-widest text-sm"
            >
              Get Free Site Audit
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
